import { BulkActionItem } from './BulkActionItem'
import { IProcessAction } from './ProcessAction'

export interface IObjectiveBulkProcessAction extends IProcessAction {
  comment: string | undefined
  assignUser: string | undefined
  assignDueDate: Date | undefined
  pendDate: Date | undefined
  pendNote: string | undefined
  bulkInboxItems: Array<BulkActionItem> | undefined
  nextInboxIdOverride: number | undefined
  priorityOverride: number | undefined
  invoiceEmailHtmlBody: string | undefined
}

export class ObjectiveBulkProcessAction implements IObjectiveBulkProcessAction {
  public comment: string | undefined
  public assignUser: string | undefined
  public assignDueDate: Date | undefined
  public pendDate: Date | undefined
  public pendNote: string | undefined
  public bulkInboxItems: Array<BulkActionItem> | undefined
  public nextInboxIdOverride: number | undefined
  public priorityOverride: number | undefined
  public invoiceEmailHtmlBody: string | undefined
}
